import React from 'react';

let Summary=props=>{
    let ingredient=props.ingredient.map(item=>{
        return <li>{item.type} {item.amount}</li>
    })
    return(
        <div>
            <ul>
                {ingredient}
            </ul>
        </div>
    )
}
export default Summary;